import { render, staticRenderFns } from "./submission-stage.vue?vue&type=template&id=2772e62c&scoped=true&"
import script from "./submission-stage.vue?vue&type=script&lang=js&"
export * from "./submission-stage.vue?vue&type=script&lang=js&"
import style0 from "./submission-stage.vue?vue&type=style&index=0&id=2772e62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2772e62c",
  null
  
)

export default component.exports